export type ProcessingTask =
    | 'EMBEDDINGS'
    | 'COMBINED_INGEST_AI'
    | 'COMBINED_INGEST_COMPLETION'
    | 'COMBINED_INGEST_EXTRACTIONS'
    | 'COMBINED_INGEST_TRANSFORMATIONS'
    | 'COMBINED_INGEST_VALIDATION_AND_TRANSFER'
    | 'COUNT_CHILDREN'
    | 'DELETE_RECORD'
    | 'DOWNLOAD_URL'
    | 'GENERATIVE_METADATA'
    | 'GET_CHILDREN'
    | 'HARVEST'
    | 'INGEST_EXTRACTION'
    | 'INSIGHTS'
    | 'KEYWORD_HARVEST'
    | 'LIST_EXTRACTIONS'
    | 'MD5'
    | 'MERGE_CHANGES'
    | 'OCR'
    | 'PRONOM'
    | 'REPRESENTATION'
    | 'RESUMABLE_UPLOAD_COMPLETED'
    | 'SET_FIELD'
    | 'SET_STATUS'
    | 'TRANSCODE'
    | 'TRANSFER'
    | 'VIRUS_CHECK'
    | 'ZIP_INGEST_INTELLECTUAL_OBJECTS'
    | 'ZIP_INGEST_FILE'
    | 'ZIP_VALIDATION'
    | 'ZIP_VALIDATION_SIDECAR';

export const COMBINED_PROCESSING_TASKS: ProcessingTask[] = [
    'COMBINED_INGEST_COMPLETION',
    'COMBINED_INGEST_EXTRACTIONS',
    'COMBINED_INGEST_TRANSFORMATIONS',
    'COMBINED_INGEST_VALIDATION_AND_TRANSFER',
    'COMBINED_INGEST_AI'
];
